import { makeStyles, lighten, darken } from "@material-ui/core";

export const DelcoteGSStyle = makeStyles((theme) => ({
    root: {},
    editsContainer: {
        display: "flex",
    },
    selectContainer: {
        display: "flex",
        flexDirection: "column",
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        "& p": {
            margin: "0.5rem 0.75rem",
        },
    },
    basecoatSelection: {
        fontFamily: "Nexa",
        fontSize: "14px",
    },
}));
